// extracted by mini-css-extract-plugin
export default {"cls1":"ButtonsPage-cls1___1bb6643c8c0d33ec41f","cls2":"ButtonsPage-cls2___09b1809b3886b68f2f6 ButtonsPage-cls1___1bb6643c8c0d33ec41f","show":"ButtonsPage-show___cbf8020172a1ff0dc9e"};